module.exports = __webpack_public_path__ + "static/img/day4.1f6e256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/day4.jpg
// module id = 9qAK
// module chunks = 0